__turbopack_context__.v({
  "description": "zom5RG_description",
  "eyebrow": "zom5RG_eyebrow",
  "header": "zom5RG_header",
  "heading": "zom5RG_heading",
  "phoneImage": "zom5RG_phoneImage",
  "phoneScreen": "zom5RG_phoneScreen",
  "phoneWrapper": "zom5RG_phoneWrapper",
  "screenImageEl": "zom5RG_screenImageEl",
  "screenVideo": "zom5RG_screenVideo",
  "section": "zom5RG_section",
});
